import type { NewTierPlan } from './getNewTierPlans';

export interface NewTierBenefit {
  description: string;
  enabled: boolean;
}

export const oneBenefits: NewTierBenefit[] = [
  { description: 'IA jurídica · 20 mensagens/mês', enabled: true },
  { description: 'Consultas jurídicas · 5 créditos/mês', enabled: true },
  { description: 'Calculadoras jurídicas · 5 créditos/mês', enabled: true },
  { description: 'Assinatura digital · 5/mês', enabled: true },
  { description: 'Oportunidades para novos clientes · 5/mês', enabled: true },
  { description: 'Monitoramento de processos · Ilimitado', enabled: true },
  { description: 'Jurisprudência · Ilimitada', enabled: true },
  { description: 'Modelos de petição · Ilimitados', enabled: true },
  { description: 'Sub-usuários · Não incluso', enabled: false },
  { description: 'E-mail profissional · Add-on', enabled: false },
  { description: 'Site personalizado · Add-on', enabled: false },
];

export const ultimateTierBenefits: NewTierBenefit[] = [
  { description: 'IA jurídica · 150 mensagens/mês', enabled: true },
  { description: 'Consultas jurídicas · 20 créditos/mês', enabled: true },
  { description: 'Calculadoras jurídicas · 20 créditos/mês', enabled: true },
  { description: 'Assinatura digital · 20/mês', enabled: true },
  { description: 'Oportunidades para novos clientes · 20/mês', enabled: true },
  { description: 'Monitoramento de processos · Ilimitado', enabled: true },
  { description: 'Jurisprudência · Ilimitada', enabled: true },
  { description: 'Modelos de petição · Ilimitados', enabled: true },
  { description: 'Sub-usuários · 3', enabled: true },
  { description: 'E-mail profissional · Add-on', enabled: false },
  { description: 'Site personalizado · Incluso', enabled: true },
];

export const blackBenefits: NewTierBenefit[] = [
  { description: 'IA jurídica · Ilimitadas', enabled: true },
  { description: 'Consultas jurídicas · 60 créditos/mês', enabled: true },
  { description: 'Calculadoras jurídicas · Ilimitadas', enabled: true },
  { description: 'Assinatura digital · 60/mês', enabled: true },
  { description: 'Oportunidades para novos clientes · 40/mês', enabled: true },
  { description: 'Monitoramento de processos · Ilimitado', enabled: true },
  { description: 'Jurisprudência · Ilimitada', enabled: true },
  { description: 'Modelos de petição · Ilimitados', enabled: true },
  { description: 'Sub-usuários · 5', enabled: true },
  { description: 'E-mail profissional · Incluso', enabled: true },
  { description: 'Site personalizado · Incluso', enabled: true },
];

export const NEW_TIER_BENEFITS_BY_KEY: Record<
  NewTierPlan['key'],
  NewTierBenefit[]
> = {
  one: oneBenefits,
  ultimate_2026: ultimateTierBenefits,
  black: blackBenefits,
};
